import axiosInstance from './axiosInstance';

const normalizeList = (data, key) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data[key])) return data[key];
  if (data && Array.isArray(data.data)) return data.data;
  return [];
};

// Map backend vendor shape → UI supplier shape (only fields from API: id, name, phone, email, address, gst_no, is_active, created_at, updated_at)
const mapVendorFromApi = (v) => {
  if (!v) return null;
  const status = v.status ?? (v.is_active === 1 || v.is_active === true ? 'active' : 'inactive');
  return {
    id: v.id,
    name: v.name ?? '',
    contact: v.phone ?? v.contact ?? '',
    phone: v.phone ?? v.contact ?? '',
    email: v.email ?? '',
    address: v.address ?? '',
    gstNumber: v.gst_no ?? v.gst_number ?? v.gstNumber ?? '',
    status: typeof status === 'string' ? status.toLowerCase() : status,
    createdAt: v.created_at,
    updatedAt: v.updated_at,
  };
};

// Map UI form → backend payload (only API fields)
const buildVendorPayload = (data) => ({
  name: data.name?.trim() || undefined,
  phone: data.contact?.trim() || data.phone?.trim() || undefined,
  email: data.email?.trim() || undefined,
  gst_no: data.gstNumber?.trim() || data.gst_no?.trim() || undefined,
  address: data.address?.trim() || undefined,
});

export const fetchVendors = async () => {
  const response = await axiosInstance.get('/vendors');
  const list = normalizeList(response.data, 'vendors') || normalizeList(response.data, 'data') || (Array.isArray(response.data) ? response.data : []);
  return list.map(mapVendorFromApi).filter(Boolean);
};

export const fetchVendorById = async (id) => {
  const response = await axiosInstance.get(`/vendors/${id}`);
  const raw = response.data?.vendor ?? response.data?.data ?? response.data;
  return mapVendorFromApi(raw);
};

export const createVendor = async (data) => {
  const payload = buildVendorPayload(data);
  const response = await axiosInstance.post('/vendors', payload);
  const created = response.data?.vendor ?? response.data?.data ?? response.data;
  return mapVendorFromApi(created);
};

export const updateVendor = async (id, data) => {
  const payload = buildVendorPayload(data);
  const response = await axiosInstance.put(`/vendors/${id}`, payload);
  const updated = response.data?.vendor ?? response.data?.data ?? response.data;
  return mapVendorFromApi(updated);
};

export const deleteVendor = async (id) => {
  await axiosInstance.delete(`/vendors/${id}`);
};

export const toggleVendorStatus = async (id) => {
  const response = await axiosInstance.patch(`/vendors/${id}/toggle-status`);
  const updated = response.data?.vendor ?? response.data?.data ?? response.data;
  return mapVendorFromApi(updated);
};
